import type { Standardprofil } from "./types.js";

/**
 * EFH Neubau Standard — Default-Profil fuer Einfamilienhaus-Neubau.
 *
 * Werte sind branchen-uebliche Annahmen, NICHT fachplanerisch nachgewiesen.
 * Bei einem konkreten Projekt sollten Fachplaner-Werte (Waermeschutz, Statik,
 * Brandschutz) Vorrang haben — siehe SAFETY_RULES.STANDARDPROFILE_AS_ANNAHME.
 */
const profil: Standardprofil = {
  id: "efh-neubau-standard",
  name: "EFH Neubau Standard",
  projektart: "Neubau",
  qualitaetsstandard: ["Basis", "Standard"],
  gewerke: {
    rohbau: {
      description:
        "Aussenwand KS-Mauerwerk d=24cm, Innenwaende KS d=11.5cm, " +
        "Decken Stahlbeton 20cm. WDVS aussen 16cm Hartschaum.",
      kriterien: {
        mauerwerksart_aussen: "Kalksandstein",
        wandstaerke_aussen_mm: 240,
        mauerwerksart_innen: "Kalksandstein",
        wandstaerke_innen_mm: 115,
        decke_material: "Stahlbeton",
        decke_dicke_mm: 200,
        wdvs_daemmstoffdicke_mm: 160,
      },
      hinweise: [
        "Wandstaerken sind Mindestannahmen — Statik kann hoeher fordern.",
      ],
    },
    putz: {
      description: "Innen Gipsputz, aussen mineralischer Oberputz auf WDVS.",
      kriterien: {
        innen_typ: "Gipsputz",
        innen_moertelgruppe: "PIV",
        innen_schichtdicke_mm: 10,
        aussen_typ: "Mineralputz",
        aussen_schichtdicke_mm: 6,
      },
    },
    maler: {
      description: "Standard-Beschichtung mit Dispersionsfarbe weiss.",
      kriterien: {
        beschichtung: "Dispersionsfarbe",
        anstriche: 2,
        klasse: "EM-konform",
        farbe: "weiss",
      },
    },
    fliesen: {
      description:
        "Bad/HWR mit Verbund-Abdichtung. Bodenfliesen rutschhemmend " +
        "(R10), Wandfliesen feinkeramisch.",
      kriterien: {
        boden_rutschhemmung: "R10",
        boden_format_cm: "30x30 oder 60x60",
        wand_typ: "Feinsteinzeug",
        verbund_abdichtung: "Pflicht",
        dichtband: "Pflicht",
        sanitärsilikon: "Pflicht",
      },
      hinweise: [
        "In Nassbereichen (Dusche/Bad) Verbundabdichtung mit Dichtband + Dichtecken nach DIN 18534.",
      ],
    },
    boden: {
      description: "Wohn-/Schlafraeume Laminat oder Parkett, Diele/Flur Fliesen.",
      kriterien: {
        wohnen_typ: "Laminat",
        wohnen_klasse: "AC4",
        flur_typ: "Fliesen",
      },
    },
    estrich: {
      description: "Schwimmender Zementestrich CT-C25-F4 mit Trittschalldaemmung.",
      kriterien: {
        typ: "Zementestrich CT-C25-F4",
        dicke_mm: 60,
        trittschalldaemmung_mm: 25,
        randdaemmstreifen: "Pflicht",
      },
    },
    trockenbau: {
      description: "Innenwaende Metallstaender + 2x Gipskarton 12.5mm.",
      kriterien: {
        staendertyp: "CW 75",
        beplankung: "2x GKB 12.5mm beidseitig",
        daemmung_mm: 60,
      },
    },
    decke: {
      description: "Abhaengung mit Metallunterkonstruktion + 1x Gipskarton.",
      kriterien: {
        unterkonstruktion: "Metall CD 60",
        beplankung: "1x GKB 12.5mm",
      },
    },
    tueren: {
      description: "Innentueren CPL beschichtet, Standardmasse 875x2010.",
      kriterien: {
        material: "CPL beschichtet",
        breite_mm: 875,
        hoehe_mm: 2010,
        anschlagrichtung: "DIN-rechts (Default)",
        zarge: "Umfassungszarge Holz",
      },
      hinweise: [
        "Anschlagrichtung muss pro Tuer im Raumbuch verifiziert werden.",
      ],
    },
    fenster: {
      description:
        "Kunststofffenster mit 3-fach Verglasung Ug=0.7 W/m2K, Uf<=1.0.",
      kriterien: {
        rahmenmaterial: "Kunststoff",
        verglasung: "3-fach",
        ug_w_m2k: 0.7,
        uf_w_m2k: 1.0,
      },
    },
  },
};

export default profil;
